import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HomeComponent } from '../../home/home.component';
import { menuOptions } from 'src/data/menu-options.data';
import { ActivatedRoute, Router } from '@angular/router';
import { OccurrenceService } from 'src/app/services/occurrence/occurrence.service';
import { OcorrenciaNovaDetalhes } from 'src/models/interfaces/ocorrencia/ocorrencia-interface';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { CommonService } from 'src/app/services/common/common.service';
import { OccurrenceLoadingKeys } from 'src/models/keys/occurrence/ocurrence.keys';
import { Observable } from 'rxjs';

@Component({
  selector: 'spe-acompanhamento',
  templateUrl: './acompanhamento.component.html',
  styleUrls: ['./acompanhamento.component.scss'],
  standalone: false
})
export class AcompanhamentoComponent implements OnInit {
  public idOcorrencia?: number;
  public idFuncionario?: number;
  public detalhes?: OcorrenciaNovaDetalhes;
  public loading$?: Observable<boolean>;

  constructor(
    private homeComponent: HomeComponent,
    public readonly route: ActivatedRoute,
    public readonly occurrenceService: OccurrenceService,
    private loadingService: LoadingService,
    readonly commonService: CommonService,
    private routerService: Router
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.commonService.autoScroll();
    }, 300);
    this.loading$ = this.loadingService.create(OccurrenceLoadingKeys.Details).loading$;
    this.route.queryParamMap.subscribe((queryParams) => {
      const idFuncionarioParam = queryParams.get('idFuncionario');
      const idOcorrenciaParam = queryParams.get('idOcorrencia');
      this.idOcorrencia = idOcorrenciaParam ? Number(idOcorrenciaParam) : undefined;
      this.idFuncionario = idFuncionarioParam ? Number(idFuncionarioParam) : undefined;
      this.homeComponent.setNewVariables(
        'Detalhes da ocorrência ' + this.idOcorrencia,
        'Verifique abaixo o detalhe da ocorrência.',
        `ocorrencias`
      );
      this.getDetalhes(this.idOcorrencia!, this.idFuncionario!);
    });
  }

  getDetalhes(idOcorrencia: number, idFuncionario: number) {
    this.occurrenceService.getOcorrenciasNovasDetalhes(idOcorrencia, idFuncionario).subscribe({
      next: (response) => {
        this.detalhes = response.detalheOcorrenciaNova;
      },
      error: () => {}
    });
  }

  private readonly months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

  private getDateParts(dateStr: string | null) {
    if (!dateStr) return null;

    // dd/MM/yyyy
    if (dateStr.includes('/')) {
      const [day, month, year] = dateStr.split(' ')[0].split('/');
      return { day, month: +month, year };
    }

    // yyyy-MM-ddTHH:mm:ss
    if (dateStr.includes('T')) {
      const [year, month, day] = dateStr.split('T')[0].split('-');
      return { day, month: +month, year };
    }

    return null;
  }

  public getDay(dateStr: string | null): string {
    return this.getDateParts(dateStr)?.day ?? '--';
  }

  public getMonth(dateStr: string | null): string {
    const month = this.getDateParts(dateStr)?.month;
    return month ? this.months[month - 1] : '';
  }

  public getYear(dateStr: string | null): string {
    return this.getDateParts(dateStr)?.year ?? '';
  }

  getStatusClass(status: string) {
    switch (status) {
      case 'Solucionado':
        return 'success-chip';
      case 'Aberto':
        return 'warning-chip';
      case 'Cancelado':
        return 'cancelled-chip';
      case 'Em Tratamento':
        return 'processed-chip';
      default:
        return 'cancelled-chip';
    }
  }

  public goToPedido = (event: Event, idPedido: number) => {
    event.stopPropagation();
    event.preventDefault();
    const url = this.routerService.serializeUrl(
      this.routerService.createUrlTree(['home/pedidos/acompanhamento/detalhar-pedido', idPedido], {
        queryParams: {
          idSolicitacao: 'segunda-via'
        }
      })
    );
    window.open(url);
  };
}
